/**
 * @generated SignedSource<<d4ff8d5996f5df0a7ed28f5a9bdd16c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteReferenceInput = {
  clientMutationId?: string | null | undefined;
  referenceId?: string | null | undefined;
  referenceRawId?: number | null | undefined;
};
export type ReferencesEditor_DeleteReferenceMutation$variables = {
  input: DeleteReferenceInput;
};
export type ReferencesEditor_DeleteReferenceMutation$data = {
  readonly deleteReference: {
    readonly reference: {
      readonly user: {
        readonly references: ReadonlyArray<{
          readonly email: string | null | undefined;
          readonly name: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ReferencesEditor_DeleteReferenceMutation = {
  response: ReferencesEditor_DeleteReferenceMutation$data;
  variables: ReferencesEditor_DeleteReferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferencesEditor_DeleteReferenceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteReferencePayload",
        "kind": "LinkedField",
        "name": "deleteReference",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Reference",
            "kind": "LinkedField",
            "name": "reference",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Reference",
                    "kind": "LinkedField",
                    "name": "references",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReferencesEditor_DeleteReferenceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteReferencePayload",
        "kind": "LinkedField",
        "name": "deleteReference",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Reference",
            "kind": "LinkedField",
            "name": "reference",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Reference",
                    "kind": "LinkedField",
                    "name": "references",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8678968523d5d3ec3ceefd2580df4af",
    "id": null,
    "metadata": {},
    "name": "ReferencesEditor_DeleteReferenceMutation",
    "operationKind": "mutation",
    "text": "mutation ReferencesEditor_DeleteReferenceMutation(\n  $input: DeleteReferenceInput!\n) {\n  deleteReference(input: $input) {\n    reference {\n      user {\n        references {\n          name\n          email\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a792a8db3abcf8cda410f2d811d51ec";

export default node;
